/**
 * Terms of Service Translations Module (French)
 * 
 * @module terms
 * @language fr
 */

export const terms = {
  pageTitle: "Conditions d'Utilisation",
  heroSubtitle: "Veuillez lire attentivement ces conditions avant d'utiliser notre plateforme.",
  lastUpdated: "Dernière mise à jour : Janvier 2026",
  effectiveDate: "En vigueur : 1er Janvier 2026",

  intro: {
    title: "Introduction",
    welcome: "Bienvenue sur l'Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI (la \"Plateforme\"). Ces Conditions d'Utilisation (\"Conditions\") régissent votre accès et votre utilisation de notre plateforme.",
    acceptance: "En accédant ou en utilisant cette Plateforme, vous acceptez d'être lié par ces Conditions. Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser la Plateforme.",
    modifications: "Nous pouvons modifier ces Conditions à tout moment. L'utilisation continue de la Plateforme après les modifications constitue l'acceptation des Conditions modifiées.",
  },

  eligibility: {
    title: "Éligibilité",
    age: "Vous devez avoir au moins 18 ans pour utiliser cette Plateforme. En utilisant la Plateforme, vous déclarez et garantissez que vous remplissez cette condition d'âge.",
    membership: "Bien que la Plateforme soit accessible au grand public, certaines fonctionnalités peuvent être réservées aux membres de la JCI ou aux utilisateurs inscrits.",
    accuracy: "Vous acceptez de fournir des informations exactes, actuelles et complètes lors de l'inscription et de maintenir et mettre à jour ces informations.",
  },

  account: {
    title: "Responsabilités du Compte",
    security: "Vous êtes responsable du maintien de la confidentialité de vos identifiants de compte et de toutes les activités qui se produisent sous votre compte.",
    notification: "Vous devez nous informer immédiatement de toute utilisation non autorisée de votre compte ou de toute autre violation de sécurité.",
    prohibition: "Vous ne pouvez pas partager vos identifiants de compte avec d'autres personnes ni permettre à d'autres d'accéder à la Plateforme en utilisant votre compte.",
  },

  acceptableUse: {
    title: "Utilisation Acceptable",
    description: "Vous acceptez d'utiliser la Plateforme uniquement à des fins légales et conformément à ces Conditions.",
    prohibited: "Vous ne pouvez pas :",
    item1: "Utiliser la Plateforme à des fins illégales ou non autorisées",
    item2: "Tenter d'obtenir un accès non autorisé à des systèmes, réseaux ou données",
    item3: "Interférer avec ou perturber la Plateforme ou les serveurs ou réseaux qui y sont connectés",
    item4: "Utiliser des moyens automatisés pour accéder à la Plateforme ou collecter des données",
    item5: "Transmettre des virus, logiciels malveillants ou autre code nuisible",
    item6: "Usurper l'identité d'une personne ou d'une entité ou déformer votre affiliation",
    item7: "Collecter des informations personnelles d'autres utilisateurs sans consentement",
    item8: "Utiliser la Plateforme pour du spam, du phishing ou des activités frauduleuses",
  },

  intellectualProperty: {
    title: "Propriété Intellectuelle",
    jciTrademarks: "JCI, Junior Chamber International, le logo JCI et toutes les marques déposées, marques de service et logos associés sont la propriété de Junior Chamber International. Vous ne pouvez pas utiliser ces marques sans autorisation écrite préalable.",
    dataLicense: "Les données, visualisations et contenus de cette Plateforme sont fournis sous la Licence Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0), sauf indication contraire.",
    restrictions: "Vous ne pouvez pas utiliser notre propriété intellectuelle à des fins commerciales sans autorisation écrite explicite.",
    platformCredits: "La Plateforme est développée et maintenue par DashCity en partenariat avec les Conseils de Développement JCI.",
  },

  dataPrivacy: {
    title: "Données et Confidentialité",
    reference: "Votre utilisation de la Plateforme est également régie par notre Politique de Confidentialité, qui décrit comment nous collectons, utilisons et protégeons vos informations personnelles.",
    link: "Veuillez consulter notre Politique de Confidentialité pour comprendre nos pratiques en matière de données.",
    gdpr: "Nous nous engageons à respecter le RGPD et à respecter vos droits en matière de protection des données.",
  },

  thirdParty: {
    title: "Services Tiers",
    description: "La Plateforme peut contenir des liens vers des sites web ou services tiers qui ne sont pas notre propriété ou sous notre contrôle.",
    disclaimer: "Nous n'avons aucun contrôle sur, et n'assumons aucune responsabilité pour le contenu, les politiques de confidentialité ou les pratiques de tout site web ou service tiers.",
    acknowledgment: "Vous reconnaissez et acceptez que nous ne serons pas responsables de tout dommage ou perte causé par ou en relation avec votre utilisation de tout contenu, bien ou service tiers.",
  },

  disclaimers: {
    title: "Avertissements",
    asIs: "LA PLATEFORME EST FOURNIE \"TELLE QUELLE\" ET \"SELON DISPONIBILITÉ\" SANS GARANTIE D'AUCUNE SORTE, EXPRESSE OU IMPLICITE.",
    noWarranty: "Nous ne garantissons pas que la Plateforme sera ininterrompue, sécurisée ou exempte d'erreurs, ou que les défauts seront corrigés.",
    accuracy: "Bien que nous nous efforcions de fournir des données et informations exactes, nous ne faisons aucune garantie quant à l'exactitude, l'exhaustivité ou la fiabilité de tout contenu sur la Plateforme.",
    research: "Les données et insights fournis sont uniquement à des fins informatives et ne doivent pas être la seule base de prise de décision.",
  },

  responsibilities: {
    title: "Vos Responsabilités",
    description: "Vous êtes responsable de votre utilisation de la Plateforme et acceptez de l'utiliser conformément aux présentes Conditions et à toutes les lois applicables. Vous comprenez que toute mauvaise utilisation de la Plateforme peut entraîner la résiliation de votre accès.",
  },

  governingLaw: {
    title: "Droit Applicable",
    jurisdiction: "Ces Conditions seront régies et interprétées conformément aux principes applicables du droit international et aux lois de la juridiction où les opérations principales de la Plateforme sont menées.",
    disputes: "Tout litige découlant de ces Conditions ou de votre utilisation de la Plateforme sera résolu par négociation de bonne foi. En cas d'échec de la négociation, les litiges peuvent être soumis à un arbitrage contraignant.",
    severability: "Si une disposition de ces Conditions est jugée inapplicable, les dispositions restantes resteront en vigueur et de plein effet.",
  },

  termination: {
    title: "Résiliation",
    byUs: "Nous pouvons résilier ou suspendre votre accès à la Plateforme à tout moment, avec ou sans motif, et avec ou sans préavis.",
    byYou: "Vous pouvez cesser d'utiliser la Plateforme à tout moment. Si vous avez un compte, vous pouvez le supprimer via la page Paramètres.",
    survival: "Les dispositions qui, par leur nature, doivent survivre à la résiliation survivront, y compris les dispositions relatives à la propriété intellectuelle, les avertissements et les limitations de responsabilité.",
  },

  contact: {
    title: "Nous Contacter",
    description: "Si vous avez des questions sur ces Conditions d'Utilisation, veuillez nous contacter :",
    email: "Email : tmariano@jci.cc",
    response: "Nous nous efforçons de répondre à toutes les demandes dans les 5 jours ouvrables.",
  },
} as const;
